import * as React from 'react';
import { Portal, Backdrop } from "./..";
export var DropdownBackdrop = function () { return (React.createElement(Portal, null,
    React.createElement(Backdrop, { lss: { zIndex: 'footer' } }))); };
//# sourceMappingURL=DropdownBackdrop.js.map